import { render } from "./xtx-infinite-loading.vue?vue&type=template&id=7456eb0a&scoped=true"
import script from "./xtx-infinite-loading.vue?vue&type=script&lang=js"
export * from "./xtx-infinite-loading.vue?vue&type=script&lang=js"

import "./xtx-infinite-loading.vue?vue&type=style&index=0&id=7456eb0a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7456eb0a"]])

export default __exports__